import { render, staticRenderFns } from "./AdditionalDescription.vue?vue&type=template&id=c882b174"
import script from "./AdditionalDescription.vue?vue&type=script&lang=js"
export * from "./AdditionalDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports